import { render, staticRenderFns } from "./shareBlog.vue?vue&type=template&id=4d744612&"
import script from "./shareBlog.vue?vue&type=script&lang=js&"
export * from "./shareBlog.vue?vue&type=script&lang=js&"
import style0 from "./shareBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports